/* eslint-disable prefer-arrow-callback, no-plusplus, no-continue, no-restricted-syntax */
import {
  Snackbar,
  Alert,
  TextField,
  Box,
  InputAdornment,
  Icon,
} from "@mui/material";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import MDBox from "theme/components/MDBox";
import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";

function FormulaValueField({ formRef, draftIndex, displayName, fieldRef, options }) {
  const [fieldError, showFieldError] = useState(false);
  const [errMsg, setErrMsg] = useState("Invalid entry provided.");

  const [number, setNumber] = useState(null);
  const [formattedNumber, setFormattedNumber] = useState("");

  function calculateValue() {
    let formula = options.formula;
    const parameters = options.parameters;
    if (parameters.length <= 0) {
      setErrMsg(`${displayName} missing calculation parameters.`);
      showFieldError(true);
      return;
    }

    for (const param of parameters) {
      const id = param.field;
      const e = document.getElementById(`dff_${id}`);
      if (typeof e === "undefined") {
        return;
      }

      const elemValue = e.value;
      const isnum = /^[0-9]\d*(\.\d+)?$/.test(elemValue);
      if (!isnum) {
        return;
      }

      const numValue = parseFloat(elemValue, 10);
      formula = formula.replaceAll(param.param, numValue);
    }

    const finalValue = eval(formula);
    // console.log(finalValue);

    if (typeof finalValue === "number") {
      setNumber(finalValue);
      const fNum = finalValue.toLocaleString("en");
      setFormattedNumber(fNum);
    }
  }

  // const form = document.getElementById("dataForm");
  // form.addEventListener("change", function () {
  //   setTimeout(calculateValue, 1000);
  // });

  function initListener() {
    const parameters = options.parameters;
    if (parameters.length <= 0) {
      setErrMsg(`${displayName} missing calculation parameters.`);
      showFieldError(true);
      return;
    }

    for (const param of parameters) {
      const id = param.field;
      const paramField = document.getElementById(`dff_${id}`);
      if (paramField === null) {
        // console.log("NULLESTTTT");
        return;
      }
      paramField.addEventListener("change", function () {
        calculateValue();
      });
    }
  }

  useEffect(() => {
    initListener();
  }, []);

  useEffect(() => {
    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [number]);

  return (
    <Box mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errMsg}
        </Alert>
      </Snackbar>
      <MDBox ml={0.5}>
        <MDTypography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </MDTypography>
      </MDBox>
      <MDInput
        type="text"
        fullWidth
        variant="outlined"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>functions</Icon>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          sx: {
            whiteSpace: "break-spaces",
          },
        }}
        value={formattedNumber}
        inputProps={{ readOnly: true, disabled: true }}
        disabled
      />
      <input
        id={`dff_${fieldRef}`}
        type="hidden"
        name={fieldRef}
        value={number}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
FormulaValueField.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

FormulaValueField.defaultProps = {
  options: null,
};

export default FormulaValueField;
